import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  userRole: 'sale',
  userEmail: '',
  accept:[],
  access_control_type: '',
  permissions: {},
  salename: '',
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    console.log('store::set ', variable, value);
    state[variable] = value
  },
}

const actions = {
  triggerLoginFlow({ commit }, userData) {
    // This function should handle user login logic
    // Placeholder for login flow
    console.log('Login triggered for:', userData);
    // After successful login, set user data
    commit('set', ['userEmail', userData.email]);
    commit('set', ['userRole', userData.role]);
  }
}

const getters = {
  role: state => {
    return state.userRole;
  },
  userEmail: state => {
    return state.userEmail;
  },
  salename: state => {
    return state.salename;
  },
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})